import { render, staticRenderFns } from "./GoGoPlane.vue?vue&type=template&id=3ff3519a&scoped=true"
import script from "./GoGoPlane.vue?vue&type=script&lang=js"
export * from "./GoGoPlane.vue?vue&type=script&lang=js"
import style0 from "./GoGoPlane.vue?vue&type=style&index=0&id=3ff3519a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3519a",
  null
  
)

export default component.exports